import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import PickRec from '@/components/DSE/PickRec';
import DatePicker from '@/components/DSE/DatePicker';
import TimestampedRTE from '@/components/TimestampedRTE';
import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import CrudOrderLines from './components/CrudOrderLines';
import { FabricOrderStatusOption } from '@/utils/constants';
import FabricOrderHeader from './components/FabricOrderHeader';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, false], // Tab 1, tab 2, ....
    labels: ['fabricOrder.tabGeneral', 'fabricOrder.orderLines'],
    names: ['general', 'line-items'],
    header: form => {
      return {
        type: FabricOrderHeader,
        props: {
          fabricOrder: form
        }
      };
    },
    groups: [
      {
        domainID: {
          type: PickRec,
          defaultValue: null,
          props: {
            caption: 'fabricOrder.domainName',
            valueField: 'id',
            labelField: 'name',
            inputField: 'name',
            maxlength: 64,
            columns: ['name', 'description'],
            entity: 'Domain',
            required: true,
            usePagination: true,
            suggest: true
          },
          rules: [{ validator: validatorRequire }],
          dynamicProps: form => {
            return {
              readonly: vue.isEdit
            };
          }
        },
        orderNumber: {
          type: MDinput,
          defaultValue: '',
          props: {
            caption: 'fabricOrder.orderNumber',
            maxlength: 16
          },
          rules: [{ validator: validatorRequire }],
          dynamicProps: form => {
            return {
              readonly: vue.isEdit
            };
          }
        },
        createdAt: {
          type: DatePicker,
          props: {
            caption: 'fabricOrder.createdAt'
          },
          dynamicProps: form => {
            return {
              readonly: vue.isEdit
            };
          }
        },
        supplierCode: {
          type: MDinput,
          defaultValue: '',
          props: {
            caption: 'fabricOrder.supplierCode',
            maxlength: 16
          },
          dynamicProps: form => {
            return {
              readonly: vue.isEdit
            };
          }
        },
        supplierName: {
          type: MDinput,
          defaultValue: '',
          props: {
            caption: 'fabricOrder.supplierName',
            maxlength: 64
          },
          dynamicProps: form => {
            return {
              readonly: vue.isEdit
            };
          }
        },
        estimatedDepartureAt: {
          type: DatePicker,
          props: {
            caption: 'fabricOrder.estimatedDepartureAt'
          },
          dynamicProps: form => {
            return {
              readonly: vue.isEdit
            };
          }
        },
        estimatedDeliveryAt: {
          type: DatePicker,
          props: {
            caption: 'fabricOrder.estimatedDeliveryAt'
          },
          rules: [{ validator: validatorRequire }],
          dynamicProps: form => {
            return {
              readonly: vue.isEdit
            };
          }
        },
        actualDeliveryAt: {
          type: DatePicker,
          props: {
            caption: 'fabricOrder.actualDeliveryAt'
          }
        },
        fabricOrderStatusOption: {
          type: Select,
          defaultValue: FabricOrderStatusOption.Expected,
          props: {
            caption: 'fabricOrder.fabricOrderStatusOption',
            valueField: 'code',
            labelField: 'description',
            loading: vue.$store.getters['option/isLoading'],
            options: vue.$store.getters['option/loadedOptions']('fabricOrderStatus')
          },
          rules: [{ validator: validatorRequireNumber }]
        },
        remarks: {
          type: TimestampedRTE,
          defaultValue: '',
          props: {
            caption: 'common.remarks'
          }
        }
      },
      {
        orderLines: {
          type: CrudOrderLines,
          defaultValue: [],
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false
          }
        }
      }
    ]
  };
}

const layoutTabGeneral = {
  named: true,
  sections: [
    {
      width: 100,
      fields: [
        'domainID',
        'orderNumber',
        'createdAt',
        'supplierCode',
        'supplierName',
        'estimatedDepartureAt',
        'estimatedDeliveryAt',
        'actualDeliveryAt',
        'fabricOrderStatusOption'
      ]
    },
    {
      width: 100,
      fields: ['remarks']
    }
  ]
};

const layoutTabOrderLines = {
  named: true,
  sections: [
    {
      width: 100,
      fields: ['orderLines']
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral]
  };
}

export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral, layoutTabOrderLines]
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
